import { AboutPage as SharedAboutPage, LeadPage } from "@lumora/ui";
import type { LeadViewModel } from "@lumora/core";

/** About Lumora; the contact (lead) form is a section of this page, there is no /contact page. */
export function LumoraAboutPage({ viewModel }: { viewModel: LeadViewModel }) {
  return (
    <SharedAboutPage
      className="site-pricing"
      title="About Lumora"
      lead="One backend, many beautiful websites."
      paragraphs={[
        "Lumora builds and hosts websites for small businesses on one shared, secure backend, so every site gets payments, ordering, and updates without extra setup.",
        "Tell us about your business below and we will get back to you.",
      ]}
    >
      <section id="contact" data-lumora-view="about-contact">
        <LeadPage className="site-contact" viewModel={viewModel} title="Contact" />
      </section>
    </SharedAboutPage>
  );
}
